import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import { legalreportShiftReport } from '../../requests/legalreports';
import { ComponentDataTable } from '../index';

const ShiftFilterDataTable = ({ customParams, moreData, columns }) => {
  const [onRequest, setOnRequest] = useState(true);
  const [shifts, setShifts] = useState([]);
  const dispatch = useDispatch();

  const handleSuccessIndex = response => {
    setShifts(response.data);
    setOnRequest(false);
  };

  const handleShiftReportRequest = params => {
    if (shifts.length > 0) {
      return;
    }
    setOnRequest(true);
    const request = async () =>
      legalreportShiftReport({
        dispatch,
        params: { ...params, ...customParams },
        successCallback: handleSuccessIndex
      });
    request();
  };

  const sortColumnCase = name => {
    switch (name) {
      case 'parsed_time':
        return { sort_time: name };
      case 'employee_full_name':
        return { sort_employee_full_name: name };
      default:
        return { sort_column: name };
    }
  };

  return (
    <>
      <ComponentDataTable
        onRequest={onRequest}
        columns={columns()}
        data={shifts}
        handleSortCase={sortColumnCase}
        moreData={moreData}
        resourceRequest={handleShiftReportRequest}
        pointerOnHover
        preName="shifts"
        noDataComponent="Sin cambios o modificaciones de turno en el periodo consultado"
        withMassActions
        withSearch={false}
        pagination
        paginationServer={false}
      />
    </>
  );
};

export default ShiftFilterDataTable;
